// When the document has finished loading — like a ship finally reaching shore after
// a long and merciless voyage — we begin our work.
document.addEventListener('DOMContentLoaded', () => {
	// We reach into the void of the DOM, searching for meaning. The section is there,
	// indifferent to our suffering.
	const section = document.querySelector('section.map-testimonials')
	const testimonialSliderEl = section.querySelector('.testimonial-slider')

	// The arrows of navigation — before and after — like the relentless passage of time itself.
	// One cannot go back, and yet here we offer the illusion.
	const before = section.querySelector('.before')
	const after = section.querySelector('.after')

	// The carousel is born. It loops eternally, as all things do in nature.
	// One slide at a time, separated by 24 pixels of emptiness —
	// a small gulf, yet infinite in its loneliness.
	var carousel = new KeenSlider(
		testimonialSliderEl,
		{
			loop: true,
			slides: {
				perView: 1,
				spacing: 24,
			},
		},
		[navigation]
	)

	// A click backward. The human desire to return to what was.
	// It is, of course, futile — the carousel simply shows another slide.
	before.addEventListener('click', () => {
		carousel.prev()
	})

	// A click forward. We march into the unknown with reckless certainty.
	after.addEventListener('click', () => {
		carousel.next()
	})

	// Even the keyboard becomes a vessel of navigation.
	// Left and right — the only directions we truly understand,
	// though the universe offers so many more.
	document.addEventListener('keydown', e => {
		if (!section.contains(document.activeElement)) return
		if (e.key === 'ArrowLeft') { e.preventDefault(); carousel.prev() }
		else if (e.key === 'ArrowRight') { e.preventDefault(); carousel.next() }
	})
})

// The navigation plugin — a function that governs the dots and the map,
// much like a director governs his actors: with quiet, obsessive control.
function navigation(slider) {
	// We find the controls wrapper, the stage upon which this small drama unfolds.
	let wrapper = document.querySelector('.map-testimonials .controls')
	// The map paths — silent territories, waiting to be illuminated or forgotten.
	const mapSections = document.querySelectorAll('.map-sections svg path')
	let dots

	// Markup: to create or to destroy. There is no middle ground.
	function markup(remove) {
		dotMarkup(remove)
	}

	// To remove an element from the DOM is to erase it from existence.
	// The parent disowns the child. It is brutal, and it is necessary.
	function removeElement(element) {
		element.parentNode.removeChild(element)
	}

	// We create a div. It is empty, meaningless — until we give it a class,
	// a name, an identity. Even HTML elements long to belong.
	function createDiv(className) {
		var div = document.createElement('div')
		var classNames = className.split(' ')
		classNames.forEach(name => div.classList.add(name))
		return div
	}

	// The dots — each one a small beacon representing a slide, a testimony, a life.
	// When clicked, they transport us. Not through space, but through stories.
	function dotMarkup(remove) {
		// If we are asked to destroy, we destroy without hesitation.
		if (remove) {
			removeElement(dots)
			return
		}
		dots = createDiv('dots')
		// For each slide, a dot is born. It listens. It waits.
		// When summoned, it obeys — but never exceeds the maximum index,
		// for even dots must respect boundaries.
		slider.track.details.slides.forEach((_e, idx) => {
			var dot = createDiv('dot')
			dot.addEventListener('click', () => {
				idx =
					idx > slider.track.details.maxIdx ? slider.track.details.maxIdx : idx
				slider.moveToIdx(idx)
			})
			dots.appendChild(dot)
		})

		wrapper.appendChild(dots)
	}

	// Sectors that represent the entire state rather than a single LHJ.
	// When any of these are present on a testimony, we light up the whole map.
	const STATEWIDE_SECTORS = ['doh', 'sboh', 'tribal', 'wsalpho']

	// Here we confront the map — a representation of Washington state,
	// its counties drawn in SVG like the contours of a dream.
	// The active slide reveals its sectors on the map. The rest fade into obscurity,
	// as all places do when we are not looking at them.
	function updateClasses() {
		var slide = slider.track.details.rel
		const fullMap = document.querySelector('.map-full')
		const slides = document.querySelectorAll(
			'.testimonial-slider .keen-slider__slide'
		)
		// data-counties is a JSON array of sector keys; fall back to an empty list.
		let counties = []
		try {
			counties = JSON.parse(slides[slide].dataset.counties || '[]')
			console.log(counties)
		} catch (e) {
			counties = []
		}
		const isStatewide =
			counties.length === 0 ||
			counties.some(c => STATEWIDE_SECTORS.includes(c))

		// Each path on the map is interrogated — does it match any of the testimony's LHJs?
		// If so, it is granted the privilege of being "active."
		// The rest are cast into darkness.
		mapSections.forEach(path => {
			if (counties.includes(path.id)) {
				path.classList.add('active')
			} else {
				path.classList.remove('active')
			}
		})
		// When the testimony speaks for the entire state, the full map awakens —
		// a rare moment of unity in this fragmented world.
		if (isStatewide) {
			fullMap.classList.add('active')
		} else {
			fullMap.classList.remove('active')
		}
		// The dots, too, must reflect reality. One is chosen. The others wait in silence.
		Array.from(dots.children).forEach(function (dot, idx) {
			if (idx === slide) {
				dot.classList.add('dot--active')
			} else {
				dot.classList.remove('dot--active')
			}
		})
	}

	// When the slider is created, we build the world and assess its state.
	slider.on('created', () => {
		markup()
		updateClasses()
	})
	// When options change, we must tear down and rebuild — like civilizations before us.
	slider.on('optionsChanged', () => {
		markup(true)
		markup()
		updateClasses()
	})
	// A slide changes. The map shifts. The dots rearrange. Life goes on.
	slider.on('slideChanged', () => {
		updateClasses()
	})
	// When the slider is destroyed, we clean up. Even in death, there is responsibility.
	slider.on('destroyed', () => {
		markup(true)
	})
}
